import { ExhibitionId } from "../../exhibitions/types";

export function publishExhibitionApiPath(exhibitionId: ExhibitionId) {
  return `exhibitions/${exhibitionId}/publish`;
}

export function unpublishExhibitionApiPath(exhibitionId: ExhibitionId) {
  return `exhibitions/${exhibitionId}/unpublish`;
}
